import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const MaskLines = ({ lines, className = "", delay = 0.2, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.06em]">
        <motion.span className="block" initial={{ y: "110%" }} animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}>
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}>
    {children}
  </motion.div>
);

export const RotatingBadge = ({ text, children, className = "" }) => (
  <div className={`relative grid h-32 w-32 place-items-center rounded-full bg-[#1c1418] text-white ${className}`}>
    <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full animate-spin-slow">
      <defs><path id="badge-circle" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0" /></defs>
      <text className="font-mono" fontSize="8.6" letterSpacing="2.6" fill="#ffffff">
        <textPath href="#badge-circle">{text}</textPath>
      </text>
    </svg>
    {children}
  </div>
);

export const Marquee = ({ items, className = "", testId }) => {
  const row = [...items, ...items];
  return (
    <div data-testid={testId} className={`overflow-hidden ${className}`}>
      <div className="flex w-max animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="flex items-center whitespace-nowrap font-display text-5xl uppercase md:text-7xl">
            {t}<span className="mx-8 text-[#e9458f]">✶</span>
          </span>
        ))}
      </div>
    </div>
  );
};
